import { render, staticRenderFns } from "./FreeSaleDetail.vue?vue&type=template&id=059e165c&"
import script from "./FreeSaleDetail.vue?vue&type=script&lang=js&"
export * from "./FreeSaleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports